/* Global UI behaviour - replaces the stateful React Header / overlays.
 * Handles: header transparency on scroll, and open/close for the
 * cart drawer, search overlay, and mobile menu. */
(function () {
  // ── Header transparency (home page only, before scroll) ──────────────
  var header = document.querySelector('[data-header]');
  if (header && header.getAttribute('data-home') === 'true') {
    var onScroll = function () {
      if (window.scrollY > 80) {
        header.classList.remove('is-transparent');
      } else {
        header.classList.add('is-transparent');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Overlay open/close (single .is-active class drives the CSS) ───────
  function openOverlay(el) {
    if (!el) return;
    el.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    if (el.hasAttribute('data-autofocus')) {
      var input = el.querySelector('input');
      if (input) setTimeout(function () { input.focus(); }, 80);
    }
  }

  function closeOverlay(el) {
    if (!el) return;
    el.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  function wire(openAttr, overlaySelector) {
    var overlay = document.querySelector(overlaySelector);
    document.querySelectorAll('[' + openAttr + ']').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openOverlay(overlay);
      });
    });
    if (overlay) {
      overlay.querySelectorAll('[data-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { closeOverlay(overlay); });
      });
    }
    return overlay;
  }

  var cart = wire('data-cart-open', '[data-cart-drawer]');
  var search = wire('data-search-open', '[data-search-overlay]');
  var menu = wire('data-menu-open', '[data-mobile-menu]');

  // ESC closes whatever is open
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    [cart, search, menu].forEach(function (o) {
      if (o && o.classList.contains('is-active')) closeOverlay(o);
    });
  });

  // ── Hero video autoplay (mobile Safari ignores the HTML muted attr) ──
  var heroVideo = document.querySelector('[data-hero-video]');
  if (heroVideo) {
    heroVideo.muted = true;            // set muted in JS so iOS allows autoplay
    heroVideo.setAttribute('muted', '');
    heroVideo.playsInline = true;
    var playHero = function () {
      var p = heroVideo.play();
      if (p && p.catch) p.catch(function () {});
    };
    playHero();
    heroVideo.addEventListener('canplay', playHero, { once: true });
    heroVideo.addEventListener('loadeddata', playHero, { once: true });
    // last-resort: kick it off on the first user touch
    document.addEventListener('touchstart', playHero, { once: true, passive: true });
  }

  // Expose for the cart script to pop the drawer after add-to-bag
  window.ASOM = window.ASOM || {};
  window.ASOM.openCart = function () { openOverlay(cart); };
  window.ASOM.closeCart = function () { closeOverlay(cart); };
})();
